<input pInputText [type]="type ? type : 'text'" [id]="id" [formControl]="ngControl.control" [class]="classToApply"/>
<rb-error-marker [control]="ngControl.control"></rb-error-marker>
